import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom-v5-compat';
import { StyledIcon } from 'src/components/foundations/foundations.styles';
import { handleSuccessToast } from 'src/components/molecules/Toast';
import theme from 'src/theme/theme';
import { ChangePasswordNew } from '../../ChangePasswordNew';
import { LoginContainer } from '../ReportingLoginContainer/ReportingLoginContainer';
import {
  Description,
  HeaderWrapper,
  FormContainer,
  BackContainer,
} from './ReportingChangePassword.styles';

export const ReportingChangePassword = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <>
      <LoginContainer>
        <BackContainer onClick={() => navigate('/reporting/reports')}>
          <StyledIcon
            className="uil uil-arrow-left"
            size="24px"
            color={theme.newPalette.turquoise.T300}
          />
          {t('reporting.ReportingChangePassword.back')}
        </BackContainer>
        <HeaderWrapper data-testid="reporting-send-reset-password-email-header">
          {t('reporting.ReportingChangePassword.header')}
        </HeaderWrapper>
        <Description data-testid="reporting-send-reset-password-email-description">
          {t('reporting.ReportingChangePassword.description')}
        </Description>
        <FormContainer>
          <ChangePasswordNew
            buttonText={t(
              'reporting.ReportingChangePassword.updatePasswordCTA',
            )}
            updateWithToken={false}
            onPasswordChangeSuccess={() => {
              navigate('/reporting/reports');
              handleSuccessToast({
                toastMessage: t(
                  'reporting.ReportingChangePassword.toastMessage',
                ),
                toastDescription: t(
                  'reporting.ReportingChangePassword.toastDescription',
                ),
              });
            }}
            isLocalised
          />
        </FormContainer>
      </LoginContainer>
    </>
  );
};
